import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

const HeightAndWeightDisplay = (props) => {
  if(!props.WeighIns) {
    return(<Grid
      container
      className="">
      <Grid 
        className=" pb2" 
        item 
        sm={6}
        xs={6}>
            <p className="modal-line ma0">-</p>
              <p className="modal-label ma0">HEIGHT</p>
      </Grid>
      <Grid 
        className=" pb2" 
        item 
        sm={6}
        xs={6}>
            <p className="modal-line ma0">-</p>
              <p className="modal-label ma0">WEIGHT</p>
      </Grid>
    </Grid>)
  }

  if(props.WeighIns.length === 0) {
    return(<Grid
      container
      className="">
      <Grid 
        className=" pb2" 
        item 
        sm={6}
        xs={6}>
            <p className="modal-line ma0">-</p>
              <p className="modal-label ma0">HEIGHT</p>
      </Grid>
      <Grid 
        className=" pb2" 
        item 
        sm={6}
        xs={6}>
            <p className="modal-line ma0">-</p>
              <p className="modal-label ma0">WEIGHT</p>
      </Grid>
    </Grid>)
  }
  return (props.WeighIns || []).map((event, idx) => {
    if(idx > 0) return '';
    return(
      <Grid
        container
        className=""
        key={idx}>
        <Grid 
          className=" pb2" 
          item 
          sm={6}
          xs={6}>
              <p className="modal-line ma0">{!event.Metric ? 
                (Math.floor(event.Height/12) + '\' ' + event.Height % 12 + '"') : 
                (event.Height + ' cm')}</p>
                <p className="modal-label ma0">HEIGHT</p>
        </Grid>
        <Grid 
          className=" pb2" 
          item 
          sm={6}
          xs={6}>
              <p className="modal-line ma0"> {Math.round(event.Weight)} {!event.Metric ? ' lbs' : ' kg'}</p>
                <p className="modal-label ma0">WEIGHT</p>
        </Grid>
      </Grid>)
    })
}

class Modal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedMember: {
        WeighIns: []
      },
      Videos: []
    }

    this.initSetup = this.initSetup.bind(this);
    this.getAthleteProfiles = this.getAthleteProfiles.bind(this);
    this.getAthleteVideos = this.getAthleteVideos.bind(this);
    this.clearSelectedMember = this.clearSelectedMember.bind(this);
    this.ordinalSuffix = this.ordinalSuffix.bind(this);
  }

  componentDidMount() {
    // Have a safety check here, basically copying the functionality from below
    if(this.props.selectedMember.AthleteId) {
      this.initSetup(this.props.selectedMember);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(!nextProps.selectedMember) {
      this.clearSelectedMember();
    }
    if(nextProps.selectedMember.AthleteId !== this.props.selectedMember.AthleteId) {
      this.initSetup(nextProps.selectedMember);
    }
  }

  initSetup(memberObject) {
    this.setState({
      selectedMember: memberObject
    }, () => {
      return this.getAthleteProfiles(this.state.selectedMember.AthleteId);
    })
  }

  getAthleteProfiles(AthleteId) {
    return fetch('https://us-central1-btwb-thewire.cloudfunctions.net/ProdAthleteProfiles?athlete_id=' + this.props.selectedMember.AthleteId, {

    }).then(res => {
      if(!res.ok) throw Error(res);

      return res.json();
    }).then(response => {
      // console.log(response)
      const mergedMember = Object.assign(response, this.state.selectedMember);

      this.setState({selectedMember: mergedMember}, () => {
        return this.getAthleteVideos(this.state.selectedMember.AthleteId)
      })
    }).catch(err => {
      console.log(err);
    })
  }

  getAthleteVideos(AthleteId) {
    return fetch('https://us-central1-btwb-thewire.cloudfunctions.net/ProdAthleteEventVideos?athlete_id=' + this.props.selectedMember.AthleteId, {

    }).then(res => {
      if(!res.ok) throw Error(res);
      return res.json();
    }).then(response => {
      if(!response) return;
      return this.setState({
        Videos: response.Videos
      });
    }).catch(err => {
      console.log(err)
    })
  }

  clearSelectedMember() {
    this.setState({
      selectedMember: {}
    })
  }

  ordinalSuffix(i) {
    var j = i % 10,
        k = i % 100;
    if (j === 1 && k !== 11) {
        return i + "st";
    }
    if (j === 2 && k !== 12) {
        return i + "nd";
    }
    if (j === 3 && k !== 13) {
        return i + "rd";
    }
    return i + "th";
  }

  render() {

    let sortedArray = [];
    const forcedParse = this.state.selectedMember.EventStandingsData ? JSON.parse(this.state.selectedMember.EventStandingsData) : [];
    (this.props.eventConfig.event_ids || []).map((eventId, idx) => {
      
      return forcedParse.map((hackingIt, idx) => {
        if(hackingIt.EventId === eventId) return sortedArray.push(hackingIt);
        return '';
      });

    })

    let videoIdx = [];

    this.state.Videos.map((video, idx) => {
      return videoIdx.push(video.EventId);
    });

    return(
      <div className={' relative'}>
        {/*Close Icon*/}
        <div 
          className="close-icon absolute top-0 right-0 mt0 mr2 pa2 pointer"
          onClick={this.props.closeModal}>
          <i className="fas fa-times"></i>
        </div>
        <div className="modal-header pt3 pl3 pr3 pb1">
          <Grid
            container
            alignItems="center">
            <Grid 
              item
              xs={4}
              className="tr pv2 pr2">
              <img alt="athlete" className="br-100" width="125" height="auto" src={(this.state.selectedMember.ImageUrl ? this.state.selectedMember.ImageUrl.replace('/small/', '/large/') : '')} />
            </Grid>
            <Grid
              item
              xs={8}
              className="pl2">
              <div className="ma0 pb1 f5 fw6 lh-solid">{this.state.selectedMember.FullName}</div>
              <p className="mt0 mb2 modal-line truncate">{this.state.selectedMember.GymName === 'Main Site' ? '' :this.state.selectedMember.GymName}</p>
              <Grid 
                container 
                
                className="o-70 f7 fh-11">
                <Grid
                  item
                  xs={8}>
                  
                  <HeightAndWeightDisplay WeighIns={this.state.selectedMember.WeighIns} />
                </Grid>
                <Grid 
                  item
                  xs={4}>
                  <p className="ma0 modal-line">{this.state.selectedMember.Gender}</p>
                  <p className="ma0 modal-label">GENDER</p>
                </Grid>
                <Grid 
                  item
                  xs={4}>
                  <p className="ma0 modal-line">{this.state.selectedMember.Age || '-'}</p>
                  <p className="ma0 modal-label">AGE</p>
                </Grid>
                <Grid 
                  item
                  xs={8}>
                  <p className="ma0 modal-line">{this.state.selectedMember.Nationality || '-'}</p>
                  <p className="ma0 modal-label">COUNTRY</p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/*social*/}
          <div className="mt2">
            <Grid 
              container 
              className="social-wrapper tc"
              spacing={8}
              justify="space-around">

              {(this.state.selectedMember.SocialLinks || []).map((link, idx) => 
                <Grid 
                  key={idx}
                  item>
                  {link.Username ? 
                    (<a 
                      href={link.Url} 
                      rel="noopener noreferrer" 
                      target="_blank"
                      className={'social social-' + link.Service.toLowerCase() + ' db relative br-100 lh-solid'}>
                      <i className={'absolute transform-center f4 lh-copy fab fa-' + link.Service.toLowerCase()}></i>
                    </a>)
                    :(<span 
                        className={'social social-' + link.Service.toLowerCase() + ' o-02 db relative br-100 lh-solid'}>
                        <i className={'absolute transform-center f4 lh-copy fab fa-' + link.Service.toLowerCase()}></i>
                      </span>)
                  }
                </Grid>
              )}
            </Grid>
          </div>
        </div>
        <Grid 
          container
          className="bg-black pa3"
          justify="space-around">
          <Grid 
            item
            className="tc">
            <div className="f4 fw6">{this.ordinalSuffix(this.state.selectedMember.PlaceRank)}</div>
            <div className="o-80">RANK</div>
          </Grid>
          <Grid 
            item
            className="tc">
            <div className="f4 fw6">{this.state.selectedMember.PlacePoints || '-'}</div>
            <div className="o-80">POINTS</div>
          </Grid>
        </Grid>
        <Grid
          className="pa3"
          container>
          {(sortedArray || []).map((event, idx) => 
            <Grid 
              key={idx + '-3'}
              container
              alignItems="center"
              className={'bl bt br bb' + (idx !== sortedArray.length - 1 ? ' mb2': '')}>
              <Grid 
                item
                className="pt2 ph3 pb3 tl fw6"
                sm={5}
                xs={5}>
                Event {idx + 1}
              </Grid>
              <Grid 
                item
                className="pt2 ph3 pb3 tr fw6"
                sm={7}
                xs={7}>
                <span className={event.PlaceRank < 4 ? 't-gold' : 't-gold'}>{this.ordinalSuffix(event.PlaceRank)}</span>
              </Grid>
              <Grid 
                item
                className="pb3 ph3 tl f7 lh-copy"
                sm={12}
                xs={12}>
                {videoIdx.indexOf(event.EventId) > -1 ? (this.state.Videos || []).map(video => {
                  if(video.EventId === event.EventId && event.ScoreRankingPhrase !== 'DNL') return(
                    <a 
                      key={video.EventId} 
                      className="relative db" 
                      target="_blank" 
                      href={video.Uri} 
                      rel="noopener noreferrer">
                      {event.ScoreRankingPhrase}    <i className="br-100 ml2 red fab fa-youtube"></i>
                    </a>
                  ); return '' }) : (
                    <div>{event.ScoreRankingPhrase}</div>
                  )
                }
                

                {event.ScorePenaltyPhrase &&
                  <p className="red mt2 mb0">* {event.ScorePenaltyPhrase}</p>
                }
              </Grid>

            </Grid>
          )}

        </Grid>
      </div>
    )
  }
}

Modal.propTypes = {
  selectedMember: PropTypes.object.isRequired,
  eventConfig: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired
}

export default Modal;